import { StoreState } from '@/redux/types';
import { getCore } from './getCore';

export function getCurrency(state: StoreState) {
  return getCore(state).currency;
}
